import { batch1Meta } from "./caCityBatch1";
import { batch2Meta } from "./caCityBatch2";
import { batch3Meta } from "./caCityBatch3";
import { batch4Meta } from "./caCityBatch4";

// Central place for company info, services, and city list.
// Swap real phone/email here once provided.

export const company = {
  name: "Coastal Surface Experts",
  shortName: "Coastal Surface Experts",
  phone: "(858) 541-1097",
  phoneHref: "tel:+18585411097",
  email: "sales@mckayroofingsolar.com",
  address: {
    city: "Pompano Beach",
    state: "FL",
    region: "Broward County",
  },
  hours: "Mon–Sat, 7:00 AM – 7:00 PM",
  tagline: "Pressure washing & soft wash services across Broward County",
  rating: 4.9,
  reviewCount: 150,
};

export type ServiceLink = {
  slug: string;
  title: string;
  short: string;
};

export const residentialServices: ServiceLink[] = [
  { slug: "house-washing", title: "House Washing", short: "Soft wash for siding, stucco & vinyl." },
  { slug: "roof-cleaning", title: "Roof Cleaning", short: "Low-pressure roof soft wash that kills algae." },
  { slug: "pressure-washing", title: "Pressure Washing", short: "All exterior surfaces, residential focused." },
  { slug: "window-cleaning", title: "Window Cleaning", short: "Streak-free interior & exterior glass." },
  { slug: "gutter-cleaning", title: "Gutter Cleaning", short: "Hand-cleared gutters + downspout flush." },
  { slug: "driveway-cleaning", title: "Driveway Cleaning", short: "Surface-cleaner finish, oil spot treatment." },
  { slug: "fence-cleaning", title: "Fence Cleaning", short: "Wood, vinyl & aluminum fences brought back." },
  { slug: "deck-cleaning", title: "Deck Cleaning", short: "Gentle cleaning for wood and composite decks." },
  { slug: "concrete-cleaning", title: "Concrete Cleaning", short: "Patios, walkways, pool decks & pavers." },
  { slug: "solar-panel-cleaning", title: "Solar Panel Cleaning", short: "Pure-water rinse to restore output." },
];

export const commercialServices: ServiceLink[] = [
  { slug: "window-cleaning", title: "Commercial Window Cleaning", short: "Storefronts, mid-rise & office windows." },
  { slug: "building-washing", title: "Building Washing", short: "Full exterior soft wash for any building." },
  { slug: "storefront-cleaning", title: "Storefront Cleaning", short: "Sidewalks, glass & entryways made spotless." },
  { slug: "drive-through-cleaning", title: "Drive-Through Cleaning", short: "Grease, gum & tire marks removed." },
  { slug: "parking-lot-cleaning", title: "Parking Lot Cleaning", short: "Lot sweeping & pressure washing." },
  { slug: "apartment-complex-cleaning", title: "Apartment Complex Cleaning", short: "Breezeways, stairs & building exteriors." },
  { slug: "dumpster-pad-cleaning", title: "Dumpster Pad Cleaning", short: "Hot water, degreaser & odor treatment." },
  { slug: "awning-cleaning", title: "Awning Cleaning", short: "Fabric & metal awnings safely cleaned." },
  { slug: "gas-station-cleaning", title: "Gas Station Cleaning", short: "Forecourt degreasing & canopy washing." },
  { slug: "fleet-washing", title: "Fleet Washing", short: "On-site fleet & truck washing programs." },
  { slug: "post-construction", title: "Post-Construction Cleanup", short: "Final exterior wash before handover." },
  { slug: "hoa-cleaning", title: "HOA Cleaning", short: "Community-wide cleaning contracts." },
];

export const browardCities = [
  "Pompano Beach",
  "Fort Lauderdale",
  "Hollywood",
  "Coral Springs",
  "Miramar",
  "Pembroke Pines",
  "Davie",
  "Plantation",
  "Sunrise",
  "Deerfield Beach",
  "Lauderhill",
  "Weston",
  "Tamarac",
  "Margate",
  "Coconut Creek",
  "Oakland Park",
  "Lauderdale Lakes",
  "North Lauderdale",
  "Wilton Manors",
  "Dania Beach",
  "Hallandale Beach",
  "Cooper City",
  "Parkland",
  "Lighthouse Point",
  "Sea Ranch Lakes",
  "Hillsboro Beach",
  "Pembroke Park",
  "Southwest Ranches",
  "West Park",
  "Lazy Lake",
  "Lauderdale-by-the-Sea",
];

// California service area cities (McKay Roofing & Solar)
export const caCities: { name: string; slug: string; blurb: string }[] = [
  ...batch1Meta.map(({ name, slug, blurb }) => ({ name, slug, blurb })),
  ...batch2Meta.map(({ name, slug, blurb }) => ({ name, slug, blurb })),
  ...batch3Meta.map(({ name, slug, blurb }) => ({ name, slug, blurb })),
  ...batch4Meta.map(({ name, slug, blurb }) => ({ name, slug, blurb })),
];

// Homepage / navigation source of truth for roofing & solar services.
export const mckayServices: { title: string; slug: string }[] = [
  { title: "Roof Repair", slug: "roof-repair" },
  { title: "Roof Replacement", slug: "roof-replacement" },
  { title: "Emergency Roof Repair", slug: "emergency-roof-repair" },
  { title: "Roof Inspection", slug: "roof-inspection" },
  { title: "Residential Roofing", slug: "residential-roofing" },
  { title: "Commercial Roofing", slug: "commercial-roofing" },
  { title: "Solar Installation", slug: "solar-installation" },
  { title: "Solar Battery Installation", slug: "solar-battery-installation" },
  { title: "Commercial Solar", slug: "commercial-solar" },
];
